import OurNatureLandscapePage from './ourNatureLandscapePage';
export default OurNatureLandscapePage;